import { Component, OnInit, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { take } from 'rxjs';
import { PropertyViews, PropertyViewsRepsonse } from '../../responses/propertyViewsResponse';
import { UserBasicDataResponse } from '../../responses/userBasicDataResponse';
import { PropertyService } from '../../services/PropertyService';
import { UserManagementApiService } from '../../services/UserManagementApiService';
import { UserContactDialogComponent } from '../dialog/user-contact-dialog.component';

@Component({ standalone: false,
  selector: 'app-property-views',
  templateUrl: './property-views.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./property-views.component.scss'] 
})
export class PropertyViewsComponent {
  readonly propertyId = input<number|undefined>(undefined);

  public busy:boolean=false;
  public views:PropertyViews[]=[];

  constructor(private propertyService:PropertyService, private umService:UserManagementApiService, private dialog:MatDialog) {
    effect(()=>{
      if(this.propertyId()){
        this.propertyService.getPropertyViews(this.propertyId()!).pipe(take(1)).subscribe((r:PropertyViewsRepsonse) =>{
          if(r.success){
            let vArray:PropertyViews[]=[];
            r.views.forEach(v=>vArray.push(Object.assign(new PropertyViews(), v)));
            this.views=vArray;
          }
        });
      }
    })
  }

  get displayedColumns(){
    return ['fullName', 'views', 'isFavorite'];
  }

  public onUserInfo(views:PropertyViews){
    if(!views.userId) return;
    this.umService.getUserBasicData(views.userId).pipe(take(1)).subscribe(r=>{
      this.userContactDialog(r);
    });
  }
  
  private userContactDialog(r:UserBasicDataResponse){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data={user:r};

    this.dialog.open(UserContactDialogComponent, dialogConfig).afterClosed().pipe(take(1)).subscribe(value=>{
      //nothing for now
    });
  }
}
